var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c('v-select', _vm._b({
    staticClass: "purchase-list-types",
    attrs: {
      "prefix": "주문유형",
      "placeholder": "전체",
      "multiple": "",
      "clearable": "",
      "flat": "",
      "dense": "",
      "solo": "",
      "hide-details": "",
      "chips": "",
      "small-chips": "",
      "persistent-placeholder": ""
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.query['type'],
      callback: function ($$v) {
        _vm.$set(_vm.query, 'type', $$v);
      },
      expression: "query['type']"
    }
  }, 'v-select', {
    items: _vm.items
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }